import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Header, IconLocation3, IconState, IconTime, IconWeather, NavHeader, Page } from '../../../../../components';
import ConditionListItem from '../../../../../components/conditions/condition-list-item';
import { ChannelTypeInternal, MeterTypeInternal } from '../../../../../data-access/gql-types/graphql';
import { isDevelopment } from '../../../../../utils/helpers';
import { useDevicesAndChannelsContext } from '../../../context/devices-and-channels';
import { ChosenConditionType } from '../enums';
import { BoxType } from '../types';
import './index.scss';

type ConditionListProps = {
  setConditionType: (type: ChosenConditionType) => void;
  isEdit: boolean;
  goToSummary: () => void;
};

export const ConditionList: React.FC<ConditionListProps> = ({ setConditionType, isEdit, goToSummary }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('action');
  const { channelList } = useDevicesAndChannelsContext();

  const automaticTypes: BoxType[] = [
    {
      type: ChosenConditionType.TIME,
      icon: <IconTime />,
      title: t('trigger.type.time.header'),
      content: t('trigger.type.time.content'),
      onClick: () => setConditionType(ChosenConditionType.TIME),
      disabled: false,
    },
    {
      type: ChosenConditionType.STATE,
      icon: <IconState />,
      title: t('trigger.type.state.header'),
      content: t('trigger.type.state.content'),
      onClick: () => setConditionType(ChosenConditionType.STATE),
      disabled: false,
    },
    {
      type: ChosenConditionType.PRICE,
      icon: <IconTime />,
      title: t('trigger.type.price.header'),
      content: t('trigger.type.price.content'),
      onClick: () => setConditionType(ChosenConditionType.PRICE),
      disabled: false,
    },
    {
      type: ChosenConditionType.LOCATION,
      icon: <IconLocation3 />,
      title: t('trigger.type.location.header'),
      content: t('trigger.type.location.content'),
      onClick: () => setConditionType(ChosenConditionType.LOCATION),
      disabled: true,
    },
    {
      type: ChosenConditionType.WEATHER,
      icon: <IconWeather />,
      title: t('trigger.type.weather.header'),
      content: t('trigger.type.weather.content'),
      onClick: () => setConditionType(ChosenConditionType.WEATHER),
      disabled: true,
    },
  ];

  const onNavHeaderClick = () => {
    if (isEdit) {
      setConditionType(ChosenConditionType.STATE);
      goToSummary();
    } else {
      navigate(-1);
    }
  };

  const priceConditionSupportedChannels = channelList.filter(
    (x) =>
      (x.data.type === ChannelTypeInternal.Meter && x.data.meterType === MeterTypeInternal.Standalone) ||
      x.data.type === ChannelTypeInternal.Optimizer,
  );

  return (
    <Page
      header={
        <>
          <NavHeader onClick={onNavHeaderClick} />
          <Header title={t('trigger.conditions.select')} isUnderline />
        </>
      }
    >
      <h2 className="condition-list__title">{t('trigger.if')}</h2>
      <div className="grid-list-24">
        {automaticTypes
          .filter((x) => !x.disabled)
          .map((item) => {
            const disabled =
              item.type === ChosenConditionType.PRICE
                ? !priceConditionSupportedChannels.length && !isDevelopment
                : item.disabled;

            return <ConditionListItem key={item.title} {...item} disabled={disabled} />;
          })}
      </div>
    </Page>
  );
};
